import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'

/**
 *  Markets
 *
 *  list/add/edit/view 
 *
 */
import Markets from '@/components/Market/Markets'

/**
 *  Products
 *
 *  list/add/edit/view 
 *
 */
import Products from '@/components/Product/Products'
import ProductAdd from '@/components/Product/ProductAdd'
import ProductEdit from '@/components/Product/ProductEdit'

/**
 *  Orders
 *
 *  add/accept
 *
 */
import OrderAdd from '@/components/Order/OrderAdd'
import OrderAccept from '@/components/Order/OrderAccept'
import OrderEdit from '@/components/Order/OrderEdit'
import orderCopyMM from '@/components/Order/orderCopyMM'

/**
 * legals
 *
 *  list
 *
 */
import Legals from '@/components/Legal/Legals'

/**
 *  Users
 *
 *  list/add/edit/view 
 *
 */
import Users from '@/components/User/Users'
import UserAdd from '@/components/User/UserAdd'
import UserEdit from '@/components/User/UserEdit'
import UserPassword from '@/components/User/UserPassword'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/markets',
      name: 'Markets',
      component: Markets,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order/add',
      name: 'OrderAdd',
      component: OrderAdd,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_LOCAL', 'ROLE_CENTRAL']
      }
    },
    {
      path: '/order/:id/accept',
      name: 'OrderAccept',
      component: OrderAccept,
      props: true,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_EDITOR', 'ROLE_CENTRAL', 'ROLE_LOCAL']
      }
    },
    {
      path: '/order/:id/copy',
      name: 'orderCopyMM',
      component: orderCopyMM,
      props: true,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_LOCAL', 'ROLE_CENTRAL', 'ROLE_EDITOR']
      }
    },
    {
      path: '/order/:id/edit',
      name: 'OrderEdit',
      component: OrderEdit,
      props: true,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_EDITOR', 'ROLE_LOCAL', 'ROLE_CENTRAL']
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR']
      }
    },
    {
      path: '/product/add',
      name: 'ProductAdd',
      component: ProductAdd,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_LOCAL', 'ROLE_CENTRAL']
      }
    },
    {
      path: '/product/:id/edit',
      name: 'ProductEdit',
      component: ProductEdit,
      props: true,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR', 'ROLE_EDITOR', 'ROLE_LOCAL', 'ROLE_CENTRAL']
      }
    },
    {
      path: '/legals',
      name: 'Legals',
      component: Legals,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR']
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR']
      }
    },
    {
      path: '/user/add',
      name: 'UserAdd',
      component: UserAdd,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR']
      }
    },
    {
      path: '/user/password',
      name: 'UserPassword',
      component: UserPassword,
      meta: {
        requiresAuth: false,
      }
    },
    {
      path: '/user/:id/edit',
      name: 'UserEdit',
      component: UserEdit,
      props: true,
      meta: {
        requiresAuth: true,
        roles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_COORDINATOR']
      },
    }
  ]
})

router.beforeEach((to, from, next) => {

  if ( to.matched.some(record => record.meta.requiresAuth) ) {

    if ( localStorage.getItem('auth_token') == null ) {

      // nie ma tokena - redirect na login
      next('/');

    }else {

      // jest token i możemy iść dalej z userem
      if(!to.meta.roles){

        // brak przypisanej roli do ścieżki 
        next();

      }else{

        // sprawdzenie czy user ma dostęp do ścieżki
        let role = localStorage.getItem('role');

        if (to.meta.roles.includes(role)){

          next();

        }else{

          next('/dashboard');

        }

      }

    }

  }else {

    // nie wymagana autoryzacja - wpuszczamy user'a
    next();

  }

});

export default router;